import { Fragment } from 'react'
import { HoverPrefetchLink } from "@/components/ui/hover-prefetch-link";
import type { ComponentProps } from 'react'
import {
 Breadcrumb,
 BreadcrumbItem,
 BreadcrumbLink,
 BreadcrumbList,
 BreadcrumbPage,
 BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'

export type BreadcrumbItemType = {
 label: string
 href?: ComponentProps<typeof HoverPrefetchLink>['href']
 current?: boolean
}

interface BreadcrumbsProps {
 items: BreadcrumbItemType[]
 className?: string
}

export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
 return (
  <Breadcrumb className={className}>
   <BreadcrumbList>
    {items.map((item, index) => {
     const isLast = index === items.length - 1
     const isCurrent = item.current ?? isLast

     return (
      <Fragment key={index}>
       <BreadcrumbItem>
        {isCurrent || !item.href ? (
         <BreadcrumbPage>{item.label}</BreadcrumbPage>
        ) : (
         <BreadcrumbLink asChild>
          <HoverPrefetchLink href={item.href}>
           {item.label}
          </HoverPrefetchLink>
         </BreadcrumbLink>
        )}
       </BreadcrumbItem>
       {!isLast && <BreadcrumbSeparator />}
      </Fragment>
     )
    })}
   </BreadcrumbList>
  </Breadcrumb>
 )
}
